import queryString from 'query-string';
import {getAccessToken} from '../actions/auth';
import logger from '../logger';

/********************
 * TYPES DEFINITION *
 ********************/

export enum HttpMethodEnum {
  GET = 'GET',
  POST = 'POST',
  DELETE = 'DELETE',
  PUT = 'PUT',
  PATCH = 'PATCH',
}

export interface IDoRequestParams {
  auth: boolean;
  method: HttpMethodEnum;
  body?: object;
  url: string;
  params?: object;
  headers?: Record<string, string>;
}

class HttpError extends Error {
  public status: number;
  public response?: any;
  public message: string;
  constructor(status: number, response: any, message: string) {
    super();
    this.status = status;
    this.response = response;
    this.message = message;
  }
}

/***********************
 * FUNCTIONS DEFINITION *
 ************************/

export const responseHandler = async (response: Response) => {
  const body = await response.json();
  if (response.status >= 200 && response.status < 300) {
    return body;
  } else {
    throw new HttpError(
      response.status,
      body,
      body.msg || body.message || 'error',
    );
  }
};

const createHeaders = async (
  mustBeAuthenticated: boolean,
  headers?: Record<string, string>,
) => {
  let commonHeaders = {
    ...headers,
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'X-Client-Type': 'website',
  };

  if (mustBeAuthenticated) {
    const token = await getAccessToken();
    if (token) {
      const Authorization = token.startsWith('JWT ') ? token : `JWT ${token}`;
      return {
        ...commonHeaders,
        Authorization,
      };
    } else {
      throw {message: 'Token is not defined', code: 100};
    }
  }

  let acceptLanguage = 'de';

  // Return calculated headers
  return {
    ...commonHeaders,
    'Accept-Language': acceptLanguage,
  };
};

export const doRequest = async (args: IDoRequestParams) => {
  try {
    // Prepare data for fetch API
    let data = {
      // Set HTTP method
      method: args.method,
      // Set request header
      headers: await createHeaders(args.auth, args.headers),
      // Add the body if exists
      ...(args.body && {body: JSON.stringify(args.body)}),
    };

    let url = args.url;

    if (args.params) {
      const recordParams: Record<any, any> = args.params;
      url += `?${queryString.stringify(recordParams)}`;
    }

    // Fetch data with fetch API
    let response = await fetch(url, data);

    //Handle response and return result
    return responseHandler(response);
  } catch (error) {
    logger.error(error);
    throw new Error(error);
  }
};
